import globalInitSlick from './modules/global_init_slick';

$(function () {
  $('.slick-preloader').busyLoad('show', {
    text: 'Loading images...',
    background: 'transparent',
    fontawesome: 'fa fa-spinner fa-spin fa-3x fa-fw',
    textColor: 'transparent',//'#cdd3de',
    color: 'transparetn', //'#cdd3de'
  });

  $(window).on('load', function () {
    $('.slick-preloader').busyLoad('hide', {
      animation: 'fade'
    });

    $('.slick-preloader').fadeOut();

    $('.slider-for').slickLightbox({
      navigateByKeyboard: true,
      src: 'src',
      itemSelector: '.slick-slide img',
      slick: {
        background: 'rgba(0,0,0,.9)',
        prevArrow: "<a class='arrows prev'><i class='fa fa-angle-left'></i></a>",
        nextArrow: "<a class='arrows next'><i class='fa fa-angle-right'></i></a>"
      }
    });
  });

  $('.slider-for').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: true,
    asNavFor: '.slider-nav',
    draggable: false,
    centerMode: false,
    prevArrow: '<a class=\'arrows prev\'><i class=\'fa fa-angle-left\'></i></a>',
    nextArrow: '<a class=\'arrows next\'><i class=\'fa fa-angle-right\'></i></a>',
  });

  $('.slider-nav').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    vertical: false,
    asNavFor: '.slider-for',
    centerMode: false,
    dots: false,
    arrows: false,
    focusOnSelect: true,
    prevArrow: "<a class='arrows prev'><i class='fa fa-angle-left'></i></a>",
    nextArrow: "<a class='arrows next'><i class='fa fa-angle-right'></i></a>",

    responsive: [{
      breakpoint: 768,
      settings: {
        slidesToShow: 4,
        vertical: false
      }
    },
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 3,
        vertical: false
      }
    }]
  });

  globalInitSlick();
});



// WEBPACK FOOTER //
// ./app/webpacker/src/js/carousel_settings.js